/**
 * A fingerprint of a planet's generated terrain (R6): FNV-1a over the bits of every height
 * and the count. Any change to the generator's output changes it. Its own module so the
 * sector core and the save code can both use it without an import cycle.
 */
export function terrainFingerprint(heights: Float32Array): string {
  const bits = new Uint32Array(heights.buffer, heights.byteOffset, heights.length);
  let h = 2166136261 ^ heights.length;
  for (let i = 0; i < bits.length; i++) h = Math.imul(h ^ bits[i], 16777619) >>> 0;
  return h.toString(16).padStart(8, '0');
}
